import { type RefObject, createContext } from 'react';

type HostedFilterEditor = {
  filterId: string;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  triggerRef: RefObject<HTMLElement>;
};

export const HostedFilterEditorContext =
  createContext<HostedFilterEditor | null>(null);
